import React from "react";
import SEO from "../components/SEO";
import Header from "../components/Header";
import Footer from "../components/Footer";

import ContactHero from "../components/ContactHero";
import ContactForm from "../components/ContactForm";
import ContactLocations from "../components/ContactLocations";

const Contact = () => {
  return (
    <>
      <SEO page="contact" />
      <Header />

      <ContactHero />

      <ContactForm />

      <ContactLocations />

      <Footer />
    </>
  );
};

export default Contact;